export default function isPlaybookDisabled(playbook) {
  return Boolean(playbook.disabledAt);
}
